
// 回到应用入口页面
import store from '@/store'
import router from '@/router'

export function goHomeBack(){
  let rootPath = store.state.app.rootPath as string
  router.replace(rootPath)
}
